import { render, staticRenderFns } from "./VCoupon.vue?vue&type=template&id=15c273f6&scoped=true&"
import script from "./VCoupon.vue?vue&type=script&lang=js&"
export * from "./VCoupon.vue?vue&type=script&lang=js&"
import style0 from "./VCoupon.vue?vue&type=style&index=0&id=15c273f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c273f6",
  null
  
)

export default component.exports